<template>
    <div class="dashboard-component" id="success" v-on:onload="verifyAccountData()">
        <div v-bind:class="bannercolor">
            <container>
                <header>
                    <div class="inner">
                        <grid horizontal="left">
                            <grid-item size="2/12" class="pointer logo-opacity">
                                <a href="/">
                                    <img class="v-middle" src="../assets/images/v-lite-white-logo.svg"><span class="logo-text">vLite</span>
                                </a>
                            </grid-item>

                            <grid-item size="10/12" class="nav-items">
                                <ul class="top-menu">
                                    <li><a href="#" @click="navigateToHomeWithDiv('howitwork')">HOW IT WORKS</a></li>
                                    <li><a href="#" @click="navigateToHomeWithDiv('features')">FEATURES</a></li>
                                    <li><a href="#" @click="navigateToHomeWithDiv('plans')">PLANS</a></li>
                                    <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                    <li><a href="#" @click="openNewTab()">SIGNIN</a></li>
                                </ul>
                            </grid-item>


                        </grid>
                    </div>
                </header>
                <div class="banner-content">
                    <h1 class="white-text">{{bannerh1}}</h1>
                    <h2 class="white-text">{{bannerh2}}</h2>
                    <grid horizontal="left" class="vl-rltv">
                        <grid-item size="8/12" class="zindex101">
                            <h4 class="banner-text-normal white-text"></h4>
                            <h4 class="banner-text-normal white-text">{{bannerh3}} <strong>{{email}}</strong>.</h4>
                            <a v-bind:href="navurl" target="_blank" v-on:click.prevent="verifyAccountData" @click="navigationBtnGA(bannerbtntext)">
                            <button v-bind:class="bannerbtn" type="button" @click="openUrlTab(navurl)">{{bannerbtntext}}</button></a>
                        </grid-item>
                        <grid-item  size="4/12" class="v-middle right zindex101 vl-bnr-top-ico">
                            <img class="v-middle right width100" src="../assets/images/gfx-bot.svg">

                        </grid-item>
                    </grid>

                </div>
            </container>
        </div>

        <div class="success-basic">
            <container >
                <p class="center success-p">{{bodyp1}}</p>
                <p class="center success-p">{{bodyp2}}</p>
                <p class="center success-p">{{bodyp3}}</p>
                <div class="clearfix"></div>
            </container>
        </div>

        <div class="success-back-color">
            <container >
                <p class="center success-help">Need Help?</p>
                <p class="center success-p">Please contact us at <strong>
                    <a style='color:#666666;' href="mailto:vlitesupport@mobiotics.com" target="_blank">vlitesupport@mobiotics.com</a></strong></p>
                <p class="center success-p">citing your vendor id (<strong>VendorId</strong>) for any help.</p>
                <div class="clearfix"></div>
            </container>
        </div>

        <!--Footer-->
        <footer class="page-footer">
            <div class="footer-color">
                <container>
                    <grid>
                        <grid-item size="4/12">
                            <div class="vl-foot-left">
                                <div class=" logo-opacity">
                                    <!-- <img class="v-middle" src="../assets/images/v-lite-white-logo.svg"><span class="logo-text">vLite</span> -->
                                    <a href="/"><img class="v-middle" src="../assets/images/logo_white.svg" style="width:20%;"></a>
                                </div>
                            <p class="foot-copy">&copy; Copyright <label id="copyrightyear"></label><a href="https://www.mobiotics.com" target="_blank">
                                <img class="v-middle foot-cmp-logo" src="../assets/images/mobiotics-logo-horizontal.svg"></a></p>

                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-mid">
                                <ul>
                                    <li><a @click="openSocialNewTab('https://www.facebook.com/mobiotics')"><icon scale="1.2" class="white-text" name="facebook"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://plus.google.com/106588943035549674608/posts')"><icon scale="1.5" class="white-text" name="google-plus"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://twitter.com/mobiotics')"><icon scale="1.2" class="white-text" name="twitter"></icon></a></li>
                                </ul>
                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-right f-right">
                            <p class="foot-copy"><a href="#">Terms Of Use</a></p>
                            <p class="foot-copy"><a href="#">Privacy Policy</a></p>
                            </div>
                            <!-- <div class="vl-foot-right">
                                <ul>
                                    <li><a href="#">Terms of use</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>
                            </div> -->
                        </grid-item>
                    </grid>
                </container>
            </div>
        </footer>
        <!-- basic -->
        <container>
        <div class="dash-loader" id="dash-loader" v-if ="loaderStatus">
            <div class="dash-loader-img">
                <svg class="lds-spin" width="100px"  height="100px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;"><g transform="translate(80,50)">
                <g transform="rotate(0)">
                <circle cx="0" cy="0" r="10" fill="#EF307E" fill-opacity="1" transform="scale(1.045 1.045)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.8333333333333334s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.8333333333333334s"></animate>
                </circle>
                </g>
                </g><g transform="translate(65,75.98076211353316)">
                <g transform="rotate(59.99999999999999)">
                <circle cx="0" cy="0" r="10" fill="#FFCA37" fill-opacity="0.8333333333333334" transform="scale(1.06167 1.06167)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.6666666666666666s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.6666666666666666s"></animate>
                </circle>
                </g>
                </g><g transform="translate(35.00000000000001,75.98076211353316)">
                <g transform="rotate(119.99999999999999)">
                <circle cx="0" cy="0" r="10" fill="#3BD7DC" fill-opacity="0.6666666666666666" transform="scale(1.07833 1.07833)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.5s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.5s"></animate>
                </circle>
                </g>
                </g><g transform="translate(20,50.00000000000001)">
                <g transform="rotate(180)">
                <circle cx="0" cy="0" r="10" fill="#EF307E" fill-opacity="0.5" transform="scale(1.095 1.095)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.3333333333333333s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.3333333333333333s"></animate>
                </circle>
                </g>
                </g><g transform="translate(34.999999999999986,24.019237886466847)">
                <g transform="rotate(239.99999999999997)">
                <circle cx="0" cy="0" r="10" fill="#FFCA37" fill-opacity="0.3333333333333333" transform="scale(1.01167 1.01167)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.16666666666666666s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.16666666666666666s"></animate>
                </circle>
                </g>
                </g><g transform="translate(65,24.019237886466843)">
                <g transform="rotate(300.00000000000006)">
                <circle cx="0" cy="0" r="10" fill="#3BD7DC" fill-opacity="0.16666666666666666" transform="scale(1.02833 1.02833)">
                  <animateTransform attributeName="transform" type="scale" begin="0s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="0s"></animate>
                </circle>
                </g>
                </g>
            </svg>
            </div>
        </div>
    </container>

    </div>



</template>

<script>
    const { Config } = require('../assets/js/config.js');

    export default{
        data(){
            return{
                loaderStatus:true,
                email: '',
                token: '',
                navurl: '#',
                bannercolor:['banner','success-banner'],
                bannerbtn:'',
                bannerh1: '',
                bannerh2:'',
                bannerh3:'',
                bannerbtntext:'',
                bodyp1:'',
                bodyp2:'',
                bodyp3:'',
                vendorid:313786,
                gaflag:true,
                apibaseurl:'',
                vendorportalurl:''
            };
        },
        created () {

        },
        mounted() {
                // Setting Config URLs
                var con = new Config();
                this.apibaseurl = con.getApiUrl();
                this.vendorportalurl = con.getPortalUrl();
                this.verifyAccountData();

                var thisYear  = new Date().getFullYear();
                console.log(document.getElementById('copyrightyear'));
                document.getElementById('copyrightyear').innerHTML = thisYear;
        },
        methods: {
            verifyAccountData(){
                console.log(this.$route.query);
                var token = this.$route.query.token;
                var email = this.$route.query.email;
                this.email = "";
                var payload = {};
                var protocol = window.location.protocol;
                var hurl = this.apibaseurl+'/vendor/v1/signup/emailverify?email='+email+'&token='+token;
                console.log(hurl);
                this.$http({url: hurl, payload: payload, method: 'GET'}).then(function (response) {
                    console.log('Success!:', response.data);
                    var data = response.data;
                    if(!(data.error))
  				        {
                            this.bannercolor = ['banner','landing-banner'];
                            this.bannerbtn = ['btn','banner-get-btn'];
                            this.bannerh1 = 'Verified';
                            this.bannerh2 = 'Your account is activated';
                            this.bannerh3 = 'Onboarding mail has been sent to ';
                            this.bannerbtntext = 'SIGN IN';
                            this.bodyp1 = 'Now you can sign in to vendor console and upload content.';
                            this.bodyp2 = 'You shall receive iOS, Android and Web Apps in next 24 hours.';
                            this.bodyp3 = 'Please test and let us know when you ready to go live.';
                            this.loaderStatus = false;
                            this.email = email;
                            this.navurl = this.vendorportalurl;
                            // GTM Code starts
                                 window.dataLayer = window.dataLayer || [];
                                 window.dataLayer.push({
                                     'event':'VLITE_EMAIL_VERIFY',
                                     'EventCategory': 'VLITE_EMAILVERIFY',
                                     'EventAction': 'EmailVerify',
                                     'EventLabel': 'EMAIL_VERIFY_SUCCESS',
                                     'EventValue': 1,
                                     'Email': email,
                                     'Status': 'Success'
                                 });
                            // End of GTM Code
                        }else{
                            if(data.error == 2127){
                                this.bannercolor = ['banner','landing-banner'];
                                this.bannerbtn = ['btn','banner-get-btn'];
                                this.bannerh1 = 'Email Already Verified';
                                this.bannerh2 = 'Your account is activated';
                                this.bannerh3 = '';
                                this.bannerbtntext = 'SIGN IN';
                                this.bodyp1 = 'Now you can sign in to vendor console and upload content.';
                                this.bodyp2 = 'You shall receive iOS, Android and Web Apps in next 24 hours.';
                                this.bodyp3 = 'Please test and let us know when you ready to go live.';
                                this.loaderStatus = false;
                                this.email = email;
                                this.navurl = this.vendorportalurl;
                            }else{
                                this.bannercolor = ['banner','failed-banner'];
                                this.bannerbtn = ['btn','banner-get-btn-failed'];
                                this.bannerh1 = 'Verification Failed';
                                this.bannerh2 = 'Your account is not activated';
                                this.bannerh3 = 'Please Try Again';
                                this.bannerbtntext = 'Try AGAIN';
                                this.bodyp1 = 'Your account not verified because of : '+data.reason;
                                this.bodyp2 = 'Please try again verify your account';
                                this.bodyp3 = '';
                                this.loaderStatus = false;
                                this.navurl = document.URL;
                                this.email = email;
                            }

                            // GTM Code starts
                                 window.dataLayer = window.dataLayer || [];
                                 window.dataLayer.push({
                                     'event':'VLITE_EMAIL_VERIFY',
                                     'EventCategory': 'VLITE_EMAILVERIFY',
                                     'EventAction': 'EmailVerify',
                                     'EventLabel': 'EMAIL_VERIFY_FAILURE',
                                     'EventValue': 1,
                                     'Email': email,
                                     'Status': 'Failed'
                                 });
                            // End of GTM Code
                        }

                }, function (response) {
                    console.log('Error!:', response.data);
                    this.bannercolor = ['banner','failed-banner'];
                    this.bannerbtn = ['btn','banner-get-btn-failed'];
                    this.bannerh1 = 'Verification Failed';
                    this.bannerh2 = 'Your account is not activated';
                    this.bannerh3 = 'Please try again';
                    this.bannerbtntext = 'TRY AGAIN';
                    this.bodyp1 = 'Your account not verified because of Network Error';
                    this.bodyp2 = 'Please try again verify your account';
                    this.bodyp3 = '';
                    this.loaderStatus = false;
                    this.navurl = document.URL;
                    this.email = email;
                    // GTM Code starts
                         window.dataLayer = window.dataLayer || [];
                         window.dataLayer.push({
                             'event':'VLITE_EMAIL_VERIFY',
                             'EventCategory': 'VLITE_EMAILVERIFY',
                             'EventAction': 'EmailVerify',
                             'EventLabel': 'EMAIL_VERIFY_FAILURE',
                             'EventValue': 1,
                             'Email': email,
                             'Status': 'Failed'
                         });
                    // End of GTM Code
                });

            },
            navigationBtnGA(btntext){
                // var text = 'SIGN IN';
                // if(btntext == 'SIGN IN'){
                //     this.$ga.event({
                //           eventCategory: 'VLITE_EMAILVERIFY',
                //           eventAction: 'SignInFromEmailVerify',
                //           eventLabel: 'VLITE_SIGNIN_EVENT',
                //           eventValue: 1,
                //           'Email': email
                //       });
                // }
                // if(btntext == 'TRY AGAIN'){
                //     this.$ga.event({
                //           eventCategory: 'VLITE_EMAILVERIFY',
                //           eventAction: 'RetryEmailVerify',
                //           eventLabel: 'VLITE_EMAILRETRY_EVENT',
                //           eventValue: 1,
                //           'Email': email
                //       });
                // }

            },
            openUrlTab(url){
                if(this.bannerbtntext == 'Try AGAIN'){
                    // GTM Code starts
                         window.dataLayer = window.dataLayer || [];
                         window.dataLayer.push({
                             'event':'VLITE_EMAIL_VERIFY_RETRY',
                             'EventCategory': 'VLITE_EMAILVERIFY',
                             'EventAction': 'RetryEmailVerify',
                             'EventLabel': 'EMAIL_VERIFY_RETRY',
                             'EventValue': 1,
                             'Email': this.email
                         });
                    // End of GTM Code
                }
                window.open(url, '_blank');
            },
            openNewTab() {
                window.open(this.vendorportalurl, '_blank');
            },
            navigateToHomeWithDiv(divname){
                this.$router.push({ name: 'Home', params: { divid: divname}});
            },
            openSocialNewTab(surl){
                window.open(surl, '_blank');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Emailverify.vue